import { render } from "./404.vue?vue&type=template&id=325cc6ee"
const script = {}

import exportComponent from "E:\\www_spf_delivery_thai\\@Developing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__